import { SimpleTextCell } from 'components/Table/Cells/SimpleTextCell';
import { Column } from 'react-table';
import { Button } from '@mui/material';
import { formatCurrency } from 'utils';
import { searchFilterByColumn } from 'components/Table/lib/searchFilters';
import { PartnerProfileStatuses } from '@trnsact/trnsact-shared-types';
import { PartnerProfileStatusBubble } from 'modules/aftermarket/partner/ui/components';
import { MultiSelectFilter } from 'components/Table/Filters/ColumnMultiSelectFilter';
import { DealerManagementCellArgs, DealerManagementPartnerLink } from 'modules/aftermarket/partner/types';

export function createTableColumns(
  tableData: DealerManagementPartnerLink[],
  handleOpenIntegrationSettingsDialog: (data: { partnerLink: DealerManagementPartnerLink }) => void,
  isIntegrationAdminAccount: boolean
): Column<DealerManagementPartnerLink>[] {
  return [
    {
      Header: 'Dealer Name',
      accessor: 'accountName',
      Cell: ({ original }: DealerManagementCellArgs) => <SimpleTextCell value={original.accountName} />,
    },
    {
      width: 200,
      Header: 'Status',
      filterable: true,
      accessor: 'metrics.status',
      filterMethod: searchFilterByColumn,
      Cell: ({ original }: DealerManagementCellArgs) => (
        <PartnerProfileStatusBubble status={original.metrics?.status as PartnerProfileStatuses} />
      ),
      Filter: ({ filter, onChange, column }: any) => (
        <MultiSelectFilter<DealerManagementPartnerLink>
          filter={filter}
          column={column}
          onChange={onChange}
          rows={tableData || []}
        />
      ),
    },
    {
      Header: 'Active Menus',
      accessor: 'metrics.activeMenus',
      Cell: ({ original }: DealerManagementCellArgs) => <SimpleTextCell value={original.metrics?.activeMenus} />,
    },
    {
      Header: 'Recent Quotes',
      accessor: 'metrics.totalSent',
      Cell: ({ original }: DealerManagementCellArgs) => <SimpleTextCell value={original.metrics?.totalSent} />,
    },
    {
      Header: 'Recent Contracts',
      accessor: 'metrics.totalSold',
      Cell: ({ original }: DealerManagementCellArgs) => <SimpleTextCell value={original.metrics?.totalSold} />,
    },
    {
      Header: 'Sold Volume',
      accessor: 'metrics.soldRetailPrice',
      Cell: ({ original }: DealerManagementCellArgs) => (
        <SimpleTextCell formatter={formatCurrency} value={original.metrics?.soldRetailPrice} />
      ),
    },
    {
      sortable: false,
      show: isIntegrationAdminAccount,
      Cell: ({ original }: DealerManagementCellArgs) => (
        <Button
          size="small"
          onClick={event => {
            event.stopPropagation();
            handleOpenIntegrationSettingsDialog({ partnerLink: original });
          }}
        >
          Integration Settings
        </Button>
      ),
    },
  ].map(header => ({
    ...header,
    resizable: false,
    headerClassName: 'customHeader',
  }));
}
